import React, { useEffect,forwardRef } from "react";
import Select from "react-select";
import './Dropdown.css'
const Dropdown = forwardRef((
  {
    className,
    options,
    isDisabled,
    isMulti,
    placeholder,
    name,
    onChange,
    width,
    height,
    isClearable,
    heightOption,
    OnselectOptionColor,
    OnOptionColor,
    value,
    isRequired,
    autoFocus,
    onBlur,
    onFocus,
    onInputChange,
    isOptionDisabled,
    hideSelectedOptions,
    components,
    fontSize
  } , ref) => {

  let initialOptionColor = "#d1cccc";
  const optionColor = () => {
    if (OnselectOptionColor) {
      initialOptionColor = OnselectOptionColor;
    }
  };

  useEffect(() => {
    optionColor();
  }, [OnselectOptionColor]);

  const theme = {
    control: (styles, state) => ({
      ...styles,
      width: width ? width : "100%",
      height: height,
      backgroundColor: state.isDisabled ? "rgb(223, 223, 223)" : "white",
      border: isRequired ? '2px solid red': "",
      boxShadow: isRequired ? "none" : "",
      fontSize: "14px",
      "&:hover": {
        cursor: "pointer",
      },
    }),
    // width ? width :
    option: (styles, state) => {
      return {
        ...styles,
        color: "black",
        width: "100%",
        height: heightOption,
        backgroundColor: state.isSelected ? initialOptionColor : "white",
        fontSize: "14px",
        zIndex:3,
        "&:hover": {
          cursor: "pointer",
          background: OnOptionColor ? OnOptionColor : "lightblue",
        },
      };
    },
    placeholder: (styles, state) => {
      return {
        ...styles,
        // color: state.isFocused ? "red":"blue",
        // "&:hover": {
        //   color: "",
        // },
      };
    },
    menu: (styles) => {
      return {
        ...styles,
        width: width ? width : "100%",
        // height:height ? height:'100%',
        // backgroundColor:'blue'
      };
    },
    multiValueLabel: (styles) => ({
      ...styles,
      // color: "#1976D2",
      // fontSize: fontSize ?? "14px",
      color: "#0c3b69",
      fontSize: fontSize ?? "14px"
      }
    ),
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#e8f0fe",
        flex: '1 0 auto'
      };
    },
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#1976D2",
      ':hover': {
        backgroundColor: "#1976D2",
        color: '#e8f0fe',
      },
    }),
    valueContainer:(styles) => ({
      ...styles,
      overflow:'auto',
      flexWrap:'unset'
    })
  };

  return (
    <>
      <Select
        className={className}
        styles={theme} //It has to be set as default
        options={options} //Array with label and value
        isDisabled={isDisabled} // bool
        onChange={onChange} //function
        isMulti={isMulti} //bool
        placeholder={placeholder? placeholder: "Select..."} // string
        name={name} //string
        isClearable={isClearable} //bool
        value={value}
        autoFocus={autoFocus}
        onBlur={onBlur}
        onFocus={onFocus}
        onInputChange={onInputChange}
        isOptionDisabled={isOptionDisabled}
        ref={ref}
        hideSelectedOptions={hideSelectedOptions}
        components={components}
        //width, height //number
      />
    </>
  );
});

export default Dropdown;
